<template>
  <div>
    <b-form-group
      :label="consulta"
      :label-for="'item-' + itemId"
      :label-cols="labelCols"
      horizontal>
      <b-form-radio-group
        :id="'item-' + itemId"
        :class="{ 'disabled': readOnly }"
        v-model="selected"
        :options="options"
        @change="setItemAprobado(selected)">
      </b-form-radio-group>
    </b-form-group>

    <!-- <b-form-group
      :label="consulta"
      :label-for="'item-' + itemId"
      :label-cols="labelCols"
      horizontal>
      <b-form-radio-group
        :id="'item-' + itemId"
        :class="{ 'disabled': readOnly }"
        v-model="selected"
        :options="options"
        buttons
        button-variant="outline-primary"
        @change="setItemAprobado(selected)">
      </b-form-radio-group>
    </b-form-group> -->
  </div>
</template>

<script>
export default {
  name: 'EncuestaUsuarioItemAprobado',
  props: {
    itemId: {
      type: Number,
      default: 0
    },
    consulta: {
      type: String,
      default: ''
    },
    itemSelected: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelCols: 8,
      selected: this.itemSelected,
      options: [
        { text: 'Si', value: true },
        { text: 'No', value: false }
      ]
    }
  },
  created() {
    if (this.readOnly) {
      this.options = [
        { text: 'Si', value: true, disabled: !this.itemSelected },
        { text: 'No', value: false, disabled: this.itemSelected }
      ]
    }
  },  
  methods: {
    setItemAprobado(aprobado) {
      this.$emit('setItemAprobado', aprobado);
    }
  }
}
</script>

<style>
  .evaluacion-usuario .btn-group-toggle .btn-outline-primary {
    width: 70px;
    cursor: pointer;
  }
  .evaluacion-usuario .btn-group-toggle.disabled .btn-outline-primary {
    cursor: default;
  }
</style>
